/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CountByMediaType,
    CountByMediaTypeFromJSON,
    CountByMediaTypeFromJSONTyped,
    CountByMediaTypeToJSON,
} from './CountByMediaType';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    SelectedMediaListLogMediaCountByTypeGetResponseAllOf,
    SelectedMediaListLogMediaCountByTypeGetResponseAllOfFromJSON,
    SelectedMediaListLogMediaCountByTypeGetResponseAllOfFromJSONTyped,
    SelectedMediaListLogMediaCountByTypeGetResponseAllOfToJSON,
} from './SelectedMediaListLogMediaCountByTypeGetResponseAllOf';

/**
 * response of GET /prtimes_media_lists/{media_list_id}/selected_media_lists/logs/{log_id}/count_by_media_type
 * @export
 * @interface SelectedMediaListLogMediaCountByTypeGetResponse
 */
export interface SelectedMediaListLogMediaCountByTypeGetResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof SelectedMediaListLogMediaCountByTypeGetResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof SelectedMediaListLogMediaCountByTypeGetResponse
     */
    message: string;
    /**
     * 履歴に含まれるメディアの種別ごとのカウントのリスト
     * @type {Array<CountByMediaType>}
     * @memberof SelectedMediaListLogMediaCountByTypeGetResponse
     */
    countByMediaTypes: Array<CountByMediaType>;
}

export function SelectedMediaListLogMediaCountByTypeGetResponseFromJSON(json: any): SelectedMediaListLogMediaCountByTypeGetResponse {
    return SelectedMediaListLogMediaCountByTypeGetResponseFromJSONTyped(json, false);
}

export function SelectedMediaListLogMediaCountByTypeGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedMediaListLogMediaCountByTypeGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'countByMediaTypes': ((json['count_by_media_types'] as Array<any>).map(CountByMediaTypeFromJSON)),
    };
}

export function SelectedMediaListLogMediaCountByTypeGetResponseToJSON(value?: SelectedMediaListLogMediaCountByTypeGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'count_by_media_types': ((value.countByMediaTypes as Array<any>).map(CountByMediaTypeToJSON)),
    };
}

